import './MyAccount.scss';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import InfoEdit from './InfoEdit';
import PasswordChange from './PasswordChange';
import DeleteAccount from './DeleteAccount';

const TABS = [
{ key: 'info',     label: '정보 수정' },
{ key: 'password', label: '비밀번호 변경' },
{ key: 'delete',   label: '계정 삭제' },
];

function MyAccount() {
const navigate = useNavigate();
const [activeTab, setActiveTab] = useState('info');

return (
    <div className='MyAccount'>
    <div className='account-container'>
        <div className='account-header'>
        <h2 className='page-title'>계정 관리</h2>
        <button className='btn-back' onClick={() => navigate(-1)}><FaArrowLeft /> 돌아가기</button>
        </div>

        <nav className='tab-nav'>
        {TABS.map((tab) => (
            <button
            key={tab.key}
            className={`tab-btn${activeTab === tab.key ? ' active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
            >
            {tab.label}
            </button>
        ))}
        </nav>

        <div className='tab-content'>
        {activeTab === 'info'     && <InfoEdit />}
        {activeTab === 'password' && <PasswordChange />}
        {activeTab === 'delete'   && <DeleteAccount />}
        </div>
    </div>
    </div>
);
}

export default MyAccount;
